import { FileDocumentType } from "@nkr/enums/document-type";

export interface IFileUpload {
    docType: FileDocumentType;
    file: File[];
    append: boolean
}